import { render, staticRenderFns } from "./ToiletBoxDeleteScreen.vue?vue&type=template&id=63a64f75&scoped=true&lang=pug"
import script from "./ToiletBoxDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./ToiletBoxDeleteScreen.vue?vue&type=style&index=0&id=63a64f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a64f75",
  null
  
)

export default component.exports